import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowDownToLine, ArrowUpFromLine } from 'lucide-react';

interface TripTypeSelectorProps {
  value: 'IMPORT' | 'EXPORT';
  onChange: (type: 'IMPORT' | 'EXPORT') => void;
  disabled?: boolean;
}

export const TripTypeSelector: React.FC<TripTypeSelectorProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-6">
      <label className="block text-sm font-medium mb-2">
        {t('trips.tripType')} <span className="text-red-500">*</span>
      </label>
      <div className="grid grid-cols-2 gap-4">
        <button
          type="button"
          disabled={disabled}
          onClick={() => onChange('IMPORT')}
          className={`
            p-4 rounded-lg border-2 transition-all flex flex-col items-center gap-2
            ${value === 'IMPORT'
              ? 'border-blue-500 bg-blue-50 text-blue-700'
              : 'border-gray-200 hover:border-gray-300 text-gray-600'
            }
            ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
          `}
        >
          <ArrowDownToLine className="w-8 h-8" />
          <span className="font-semibold">{t('trips.import')}</span>
          <span className="text-xs text-center opacity-75">
            {t('trips.importDesc')}
          </span>
        </button>

        <button
          type="button"
          disabled={disabled}
          onClick={() => onChange('EXPORT')}
          className={`
            p-4 rounded-lg border-2 transition-all flex flex-col items-center gap-2
            ${value === 'EXPORT'
              ? 'border-green-500 bg-green-50 text-green-700'
              : 'border-gray-200 hover:border-gray-300 text-gray-600'
            }
            ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
          `}
        >
          <ArrowUpFromLine className="w-8 h-8" />
          <span className="font-semibold">{t('trips.export')}</span>
          <span className="text-xs text-center opacity-75">
            {t('trips.exportDesc')}
          </span>
        </button>
      </div>
    </div>
  );
};
